import React, { memo } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Col, Info, Row, Typography } from 'redpoints-front-components/index';

import { getTestPurchaseLinkInfoAddress } from '../../../reducers/tasks/testPurchase';
import { TextWithCopyIcon } from './../../../helpers/copyHelper';
import { translate } from './../../../helpers/languageHelper';

import './testPurchaseAddress.less';

const TestPurchaseAddress = ({
  address: {
    city = '',
    fullName = '',
    telephoneNumber = '',
    address = '',
    zipCode = '',
    state = '',
    email = '',
  },
}) => (
  <div className="test-purchase-address">
    <Typography blockTypes={['title2']}>
      {translate('tasks.testPurchase.address.title')}
    </Typography>
    <Row gutter={[16, 16]}>
      <Col md={4}>
        <Info
          label={translate('tasks.testPurchase.address.fields.fullName')}
          value={<TextWithCopyIcon text={fullName} />}
        />
      </Col>
      <Col md={4}>
        <Info
          label={translate('tasks.testPurchase.address.fields.telephone')}
          value={<TextWithCopyIcon text={telephoneNumber} />}
        />
      </Col>
      <Col md={5}>
        <Info
          label={translate('tasks.testPurchase.address.fields.address')}
          value={<TextWithCopyIcon text={address} />}
        />
      </Col>
      <Col md={3}>
        <Info
          label={translate('tasks.testPurchase.address.fields.zipCode')}
          value={<TextWithCopyIcon text={zipCode} />}
        />
      </Col>
      <Col md={3}>
        <Info
          label={translate('tasks.testPurchase.address.fields.city')}
          value={<TextWithCopyIcon text={city} />}
        />
      </Col>
      <Col md={3}>
        <Info
          label={translate('tasks.testPurchase.address.fields.state')}
          value={<TextWithCopyIcon text={state} />}
        />
      </Col>
      <Col md={5}>
        <Info
          label={translate('tasks.testPurchase.address.fields.email')}
          value={<TextWithCopyIcon text={email} />}
        />
      </Col>
    </Row>
  </div>
);

const mapStateToProps = state => ({
  address: getTestPurchaseLinkInfoAddress(state),
});

export default compose(connect(mapStateToProps), memo)(TestPurchaseAddress);
